module.exports = __webpack_public_path__ + "media/components/VendingCart/assets/thumbnail-ceac1c6e28f66c9047fbf6311447229a.svg";